import { ElementRef } from '@angular/core';
import { AfterViewInit, Component, ViewChild, OnInit } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { NgbModal,ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { from, Subject } from 'rxjs';
import { CommonService } from 'src/app/services/common.service';
import { APIService } from '../../api.service';


@Component({
  selector: 'app-hsn-list',
  templateUrl: './hsn-list.component.html',
  styleUrls: ['./hsn-list.component.scss']
})
export class HSNListComponent implements OnInit {

  displayedColumns: string[] = ['H','C','Per','edit','delete'];
  dataSource = new MatTableDataSource();

  agencyData: any = [];
  jarvisData: any = []; 
  editDataArry: any = [];
  editId: number = 0;

  @ViewChild('HSNCodetable', { static: false }) HSNCodetable!: ElementRef;
  @ViewChild(MatSort) sort!: MatSort;
  modalReference: any;
  closeResult: any;

  changingValue: Subject<boolean> = new Subject();
  changingHeadValue: Subject<boolean> = new Subject();
  data = {
    'H': "",
    'Per' : '',
    'C': '',
    'HID':0,
  };
  
  oldHSNNO: any;
  editIndex: number = -1;

  
  @ViewChild(MatSort) set matSort(sort: MatSort) {
    this.dataSource.sort = sort;
  }

  @ViewChild(MatPaginator) 
  set paginator(value: MatPaginator) {
    this.dataSource.paginator = value;
  } 
  constructor(private router: Router,private modalService: NgbModal,private apiService: APIService,public commonService: CommonService) { }

  ngOnInit(): void {
    let agencyData = this.apiService.getCookie("M");
    if (agencyData) {
      this.agencyData = JSON.parse(agencyData);
    }
    var jarvis = this.apiService.getCookie("Jarvis");
    if (jarvis) {
      this.jarvisData = JSON.parse(jarvis);
    }
    this.dataSource.sort = this.sort;

    this.getData();
  }

  // getHSN NO Code() - get all HSN/NO Code from database
  getData(){
    let myParams = [{
        myUserID: this.jarvisData[0].UserID,
        myToken: this.jarvisData[0].WebToken,
        forAgencyID: this.jarvisData[0].AgencyIDs,
        myAgencyIDs: this.jarvisData[0].AgencyIDs,
        ForERPAgencyID: this.agencyData[0].ERPAgencyID,
        myLastSyncDT: null,
        isWeb: true,
        actionType: 'getConfig',
        moduleID: 6,
        data: ''
    }];
    this.apiService.getData(myParams, this.successResp.bind(this), this.failureResp.bind(this));
    }
  
    //successResp - success  get handler
    successResp(res: any) {
      if (res.error) {
      }
      else {
          if (res) {
              var reponseData = JSON.parse(res.updatePackage);
              if (reponseData.Table2) {
                  this.editDataArry = JSON.parse(reponseData.Table2[0].HSNSAC);
                  this.dataSource.data = this.editDataArry;
                  this.dataSource.paginator = this.paginator;
                  this.dataSource.sort = this.matSort
              }   
          }
      }
  }

  //failureResp - failure handler
  failureResp(res: any) {
    if (res.error) {
    }
  }

 //Add <--&--> Edit HSN-NO Open Model
  AddHsnModel(content: any, id: number) {
    this.data.H ='';
    this.data.C = '';
    this.data.Per = '';

    this.editId = id;

    if(this.editId > 0){
      var id = this.editId ;
      var HSNdata = this.editDataArry.filter(function (element: any, index: any) {        
      return (element.HID == id);
      });

      for(let i = 0; i < this.editDataArry.length; i++){
        if(this.editDataArry[i].HID == id){
          this.editIndex = i;
          break;
        }
      }

      this.data.H = HSNdata[0].H;
      this.data.C = HSNdata[0].C;
      this.data.Per = HSNdata[0].Per;
    }

    this.modalReference = this.modalService.open(content,{windowClass: "AddHsnModel", backdrop: 'static', keyboard: false });
    this.modalReference.result.then((result: any) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason: any) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

//Clode Model HSN NO
  public closeModal($event: any) {
    this.modalReference.close();
    if ($event) {
      this.changingValue.next($event);
      this.changingHeadValue.next($event);
    }
  }

//Entry HSN/No Code......
  newHsn(){
    if (this.data.H == "") {
      this.apiService.successAlert('Please enter HSNNo no.');
        return;
    }
    else if (this.data.C == "") {
      this.apiService.successAlert('Please enter Description');
        return;
    }

    else if (this.data.Per == "") {
      this.apiService.successAlert('Please enter Per%');
      return;
  }
    if(this.editIndex == -1){
      var temp = {
          'HID': this.editDataArry.length + 1,
          'H': this.data.H,
          'C': this.data.C,
          'Per': Number(this.data.Per),
        }
        let flag = false;

//Start Duplicate validation
          for (let i = 0; i < this.editDataArry.length; i++) {
            if(this.data.C.toUpperCase() == this.editDataArry[i].C.toUpperCase()){
              flag = true
              break;;
            }
          }
        if(!flag){
          this.data.C = '';
        }
        else
        {
          this.apiService.successAlert("This category is already exists.")
          this.data.C = '';
          return;
        } 
//End Duplicate validation
        this.editDataArry.push(temp);
    }
    else
    {
      this.editDataArry[this.editIndex].H = this.data.H;
      this.editDataArry[this.editIndex].C = this.data.C;
      this.editDataArry[this.editIndex].Per = Number(this.data.Per);
    }

        this.save();
  }

//save - save HSNNO/Code
save() {  
            var tempData = [{
              'ChangeType': 'HSNSAC',
              'GSTLdgrs':'',
              'Units': '',
              'Stores':'',
              'ItemCategories': '',
              'PrdJobStages': '',
              'ValnMethod':1,
              'PrdRejnReasons': '',
              'HSNSAC': JSON.stringify(this.editDataArry)
          }]
            let myParams = [{
                myUserID: this.jarvisData[0].UserID,
                myToken: this.jarvisData[0].WebToken,
                forAgencyID: this.jarvisData[0].AgencyIDs,
                myAgencyIDs: this.jarvisData[0].AgencyIDs,
                myLastSyncDT: null,
                isWeb: true,
                ForERPAgencyID: this.agencyData[0].ERPAgencyID,
                actionType: 'set',
                moduleID: 6,
                data: JSON.stringify(tempData)
            }];
            this.apiService.sendChange(myParams, this.editsuccessResp.bind(this), this.editfailureResp.bind(this));
            this.modalReference.close();
          } 
          
//successHSN/NO entry - success HSN/NO entry handler
    editsuccessResp(res: any) {
    if (res.error) {
    }
    else {
      this.editIndex = -1;
      this.getData();
    }
  }

  //failureResp - failure handler
  editfailureResp(res: any) {
   // debugger
    if (res.error) {
    } 
  }

//Delete HSN/NO Code
deleteHSN(ind: number) {
            if(confirm("Are you sure delete this HSN/SAC Code?")) {
              this.editDataArry.splice(ind, 1);
              this.save();
            }
          }   

   //Type numberOnly Input text
 numberOnly(event: any): boolean {
  return this.commonService.numberOnly(event);
  }        
}      


 

